export type AssetLibraryModel = {
  attachment_count?: number,
  cache_key: number,
  dates: {
    created: {
      date_time: string,
    },
  },
  id: number,
  owner_id: number,
  owner_type: string,
  title: string,
}

export type AssetLibraryRequestOptions = {}

const state = {
  id: null,
  owner_id: null,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'title' },
]

export default state
